import { useComment } from "@/hooks/useComment";
import { CommentScope } from "@/interfaces/comment.interface";
import { currentUserState } from "@/stores/common";
import { useMediaQuery } from "@material-ui/core";
import { Comment } from "antd";
import dynamic from "next/dynamic";
import React from "react";
import { useRecoilValue } from "recoil";
import DynamicMyAvatar from "../MyAvatar/DynamicMyAvatar";
import MyCommentList from "./components/CommentList/MyCommentList";
import styles from "./styles.module.less";

const Editor = dynamic(() => import("./components/Editor"), { ssr: false });

const { container } = styles;

interface IProps {
  fatherId: string;
  url?: string;
  scope?: CommentScope;
}

const MyComment: React.FC<IProps> = ({ fatherId, url, scope = "all" }) => {
  const { addComment, loadingAdd } = useComment(fatherId, scope);
  const currentUser = useRecoilValue(currentUserState);
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <div className={container}>
      <MyCommentList fatherId={fatherId} scope={scope} />
      {currentUser?.id && (
        <Comment
          avatar={
            matches && (
              <DynamicMyAvatar
                src={currentUser?.avatarUrl}
                alt={currentUser?.username}
              />
            )
          }
          content={
            <Editor
              fatherId={fatherId}
              handleSubmit={addComment}
              submitting={loadingAdd}
              url={url}
            />
          }
        />
      )}
    </div>
  );
};

export default MyComment;
